<div  *ngIf="displayMode === 'default'" class="loginFormWrapper"
     [class.media-handset]="layoutMatches.isHandsetDefaultLayout">
  <section
    class="login-form-section">
    <div class="progress-bar-spinner" [class.dark-grey-red-theme]="true">
      <mat-progress-bar style="margin: 0px; padding: 0px;" *ngIf="application.isActiveRequest" color="accent"
                        mode="indeterminate"></mat-progress-bar>
    </div>
    <mat-card class="login-form-card">
      <img src="{{application.account.logo}}" class="login-logo" alt="Account Logo" />
      <section *ngIf="this.state=='default' || this.state=='success'">
        <form [formGroup]="resetForm" (ngSubmit)="onResetSubmit()">
          <h1 class="text-center">Change password</h1><br />
          <section style="margin-bottom: 10px;" *ngIf="!resetStatus" class="text-center">
            <span class="infoText">
              Please change your password for security purposes.
            </span>
          </section>

          <div class="errorContainer" *ngIf="resetStatus == 'error'">
            <mat-icon class="loginErrorIcon" [class.extraErrorIconSpace]="resetMessage.length>45" color="warn">error</mat-icon>
            {{resetMessage ? resetMessage : 'Sorry, error occured. Please contact support.'}}
          </div>

          <section *ngIf="state=='default'">
            <div class="form-group">
              <mat-form-field appearance="outline" class="form-field" color="accent">
                <mat-label>New password</mat-label>
                <input matInput formControlName="password" type="password" value="">
                <mat-error class="form-error" *ngIf="this.resetFormErrors['password']">
                  {{this.resetFormErrors['password']}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field appearance="outline" class="form-field" color="accent">
                <mat-label>Confirm password</mat-label>
                <input matInput formControlName="confirm_password" type="password" value="">
                <mat-error class="form-error" *ngIf="this.resetFormErrors['confirm_password']">
                  {{this.resetFormErrors['confirm_password']}}
                </mat-error>
              </mat-form-field>
            </div>
          </section>
          <div class="form-group">
            <mat-grid-list cols="2" rowHeight="4:1">
              <mat-grid-tile>
                <section class="leftLink" *ngIf="this.state!='success'">
                  <a class="quicklink font16" (click)="logout()">
                    Back to Sign in
                  </a>
                </section>
              </mat-grid-tile>
              <mat-grid-tile>
                <section style="width:100%; text-align: right;" *ngIf="this.state=='default'">
                  <button mat-raised-button color="accent" class="widerButton" style="padding: 0px 16px;">CHANGE PASSWORD</button>
                </section>
              </mat-grid-tile>
            </mat-grid-list>
          </div>
        </form>
      </section>
    </mat-card>
  </section>
</div>

<form class="popupForm" *ngIf="displayMode === 'popup'" [formGroup]="resetForm" (ngSubmit)="onResetSubmit()">
  <div class="common loginFormWrapper" mat-dialog fxLayout="column" fxLayoutAlign="space-between"
       (keydown.enter)="handleCopy($event)">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      Password change
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" id="form-content" [class.hasContentScroll]="hasContentScroll">
      <div class="errorContainer" *ngIf="resetStatus == 'error'">
        <mat-icon class="loginErrorIcon" [class.extraErrorIconSpace]="resetMessage.length>45" color="warn">error</mat-icon>
        {{resetMessage ? resetMessage : 'Sorry, error occured. Please contact support.'}}
      </div>

      <section *ngIf="state=='default'" class="popup-form-inputs">
        <div class="form-group">
          <mat-form-field appearance="outline" class="form-field" color="accent">
            <mat-label>Old password</mat-label>
            <input matInput formControlName="old_password" type="password" value="">
            <mat-error class="form-error" *ngIf="this.resetFormErrors['old_password']">
              {{this.resetFormErrors['old_password']}}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field appearance="outline" class="form-field" color="accent">
            <mat-label>New password</mat-label>
            <input matInput formControlName="password" type="password" value="">
            <mat-error class="form-error" *ngIf="this.resetFormErrors['password']">
              {{this.resetFormErrors['password']}}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field appearance="outline" class="form-field" color="accent">
            <mat-label>Confirm password</mat-label>
            <input matInput formControlName="confirm_password" type="password" value="">
            <mat-error class="form-error" *ngIf="this.resetFormErrors['confirm_password']">
              {{this.resetFormErrors['confirm_password']}}
            </mat-error>
          </mat-form-field>
        </div>
      </section>
    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        Cancel
      </button>
      <button mat-raised-button color="accent" class="widerButton font16" style="padding: 0px 16px;">Change Password</button>
    </div>
  </div>
</form>